<template>
    <ModalFormCard class="modal-default" :action='""'>
        <template #title>Lead notifications</template>

        <template #default="{ saving, errors }">
            
            <template v-for='(user, index) in users'>
                <div class='grid grid-cols-5 text-15 gap-2 pb-6'>
                    <div class='col-span-3 font-semibold'>{{ user.fullName() }}</div>
                    <div class='text-center text-grey-900 text-13'>
                        <template v-if='index == 0'>Notifications</template>
                    </div>
                    <div class='text-center text-grey-900 text-13'>
                        <template v-if='index == 0'>Calls</template>
                    </div>

                    <template v-for='key in ["email", "contact_number_1", "contact_number_2", "contact_number_3"]'>
                        <template v-if='user[key] != null'>
                            <div class='col-span-3'>
                                <template v-if='key != "email"'>{{ $help.e164ToNumber(user[key]) }}</template>
                                <template v-else>{{ user[key] }}</template>
                            </div>
                            <div class='text-center text-grey-900 flex justify-center'>
                                <InputCheckbox />
                            </div>
                            <div class='text-center text-grey-900 flex justify-center'>
                                <InputCheckbox v-if='key != "email"' />
                            </div>
                        </template>
                    </template>
                </div>
            </template>

            <div class="modal-buttons !pt-0">
                <ButtonSaving :disabled="saving" class="default button-black h-12 px-6">
					Update
				</ButtonSaving>
            </div>
        </template>
    </ModalFormCard>
</template>

<script>
    import Modal from '~/mixins/modal.js'
    import User from '~/models/user.js'

    export default {
        mixins: [Modal],

        data() {
            return {
                users: null,
                value: {
                }
            }
        },

        created() {
            this.getUsers()
        },

        methods: {
            getUsers() {
                this.$axios.post('/admin/actions/subscription/'+this.editingModel.id+'/subscription-get-users')
                    .then(res => {
                        this.users = User.fill(res);
                    })
            }
        },

        computed: {
            subscription() {
                return this.editingModel
            },
        }
    }
</script>